import { format } from "date-fns";
import React, { useEffect, useState, useRef } from "react";
import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";
import RetagDocumentModal from "../components/details/RetagDocumentModal";
import PdfViewer from "./PdfViewer";
import { convertToUTCFormat } from "../utils/format";

const ImageContainer = ({
  step,
  id,
  onDocumentChange,
  documents,
  docSelected,
  rotate,
  rotationId,
  prevDoc,
  nextDoc,
  canScroll,
  enableScroll,
  showScroll,
  lead_id,
  dis_id,
  hideAddedDate,
  sub_stage,
  dts_pay_count,
  is_reassigned,
  stepSelected,
}) => {
  const [showRetagModal, setShowRetagModal] = useState(false);
  const transformWrapperRef = useRef(null);

  useEffect(() => {
    transformWrapperRef?.current?.resetTransform(); // Call resetTransform on docSelected change
  }, [stepSelected]);

  return (
    <div className="galyBox">
      {showRetagModal && (
        <RetagDocumentModal
          closeRetagModal={() => setShowRetagModal(false)}
          doc={documents[docSelected]}
          origin={documents[docSelected].origin}
          lead_id={lead_id}
          dis_id={dis_id}
        />
      )}
      <select
        className="form-control"
        id={`doc_gallery- step${step}-${id}`}
        name={`doc_gallery- step${step}-${id}`}
        onChange={onDocumentChange}
        value={docSelected}
      >
        {documents.map(({ document_name, uploaded_date }, index) => {
          return (
            <option value={index} key={`${id}-${index}`}>
              {document_name}{" "}
              {!hideAddedDate
                ? convertToUTCFormat(
                    new Date(uploaded_date ? uploaded_date : "0000:00:00"),
                    "yyyy-MM-dd kk:mm:ss"
                  )
                : ""}
            </option>
          );
        })}
      </select>

      <TransformWrapper
        limitToBounds={false}
        ref={transformWrapperRef}
        velocityAnimation={{
          disabled: true,
          equalToMove: false,
          sensitivity: 0,
        }}
      >
        {({ zoomIn, zoomOut, resetTransform }) => {
          return (
            <React.Fragment>
              {documents[docSelected] &&
              documents[docSelected].extension !== "pdf" ? (
                <div
                  className={`action-buttons action-btn-step${step}-${id}`}
                  id={`action-buttons-step${step}-${id}`}
                >
                  {step !== 4 && id === 2 && (
                    <button
                      className={`gallery-retag-in-step${step}-${id} zoom-sprite ic-zoom-edit`}
                      onClick={(e) => {
                        setShowRetagModal(true);
                        e.stopPropagation();
                      }}
                    ></button>
                  )}
                  <button
                    className={`gallery-zoom-in-${step}-${id} zoom-sprite ic-zoom-in image_action-${step}-${id}`}
                    onClick={() => zoomIn()}
                  ></button>
                  <button
                    className={`gallery-zoom-out-step${step}-${id} zoom-sprite ic-zoom-out image_action-${step}-${id}`}
                    onClick={() => zoomOut()}
                  ></button>
                  <button
                    className={`rotate-step${step}-${id} zoom-sprite ic-rotate  image_action-step${step}-${id}`}
                    onClick={() => rotate(id)}
                  ></button>
                  <button
                    className={`rotate-back-step${step}-${id} zoom-sprite ic-fullscreen  image_action-step${step}-${id}`}
                    onClick={() => resetTransform()}
                  ></button>
                  {showScroll && (
                    <button
                      className={`add-scroll-step${step}-${id} zoom-sprite ic-change-scroll  image_action-step${step}-${id}`}
                      onClick={() => enableScroll(id - 1)}
                    ></button>
                  )}
                </div>
              ) : (
                ""
              )}

              <div id={`image-gallery-step${step}-${id}`}>
                <div className="image-container">
                  <div
                    className={`image_div-step${step}-${id}`}
                    style={{
                      overflow: `${
                        showScroll && canScroll[id - 1] ? "scroll" : "hidden"
                      }`,
                    }}
                  >
                    <div className="image_wrap">
                      {documents[docSelected]?.extension === "pdf" ? (
                        <PdfViewer
                          url={documents[docSelected].signed_url}
                          openRetagModal={(e) => {
                            setShowRetagModal(true);
                            e.stopPropagation();
                          }}
                          sub_stage={sub_stage}
                          dts_pay_count={dts_pay_count}
                          is_reassigned={is_reassigned}
                          stepSelected={stepSelected}
                        />
                      ) : (
                        <></>
                      )}
                      <TransformComponent>
                        {documents[docSelected] &&
                        documents[docSelected].extension !== "pdf" ? (
                          <img
                            className="image_tag content"
                            src={
                              documents[docSelected].signed_url
                                ? documents[docSelected].signed_url
                                : ""
                            }
                            alt="Not Available"
                            style={{
                              transform: `rotate(${rotationId * 90}deg)`,
                              width: "100%",
                            }}
                          />
                        ) : (
                          ""
                        )}
                      </TransformComponent>
                    </div>
                  </div>
                </div>
                <span
                  className="prev_btn"
                  onClick={() => {
                    prevDoc(id - 1);
                    resetTransform();
                  }}
                >
                  <span className="zoom-sprite ic-prev"></span>
                </span>
                <span
                  className="next_btn"
                  onClick={() => {
                    nextDoc(id - 1);
                    resetTransform();
                  }}
                >
                  <span className="zoom-sprite ic-next"></span>
                </span>
              </div>
            </React.Fragment>
          );
        }}
      </TransformWrapper>
    </div>
  );
};

export default ImageContainer;
